import { useUserStore } from "@/stores/user";
import type { MiddlewareContext } from "@/types";

// Redirect to an error page if ecommerce is disabled for students in the Org and they try to navigate to any ecommerce pages
export const blockEcommerce = ({ next, router }: MiddlewareContext) => {
  const store = useUserStore();

  const blockEcommerce =
    store.user?.current_org?.security_settings?.disable_ecommerce && store.isOnlyLearner;

  if (blockEcommerce) {
    router.push({
      path: "/ecommerce-disabled"
    });
    return;
  }

  return next();
};
